import { GENERIC_SSM_SETUP_ERROR_CODE } from './constants.ts';

class SsmError extends Error {
    public code: number;

    constructor(_code?: number, ...params: any[]) {
        super(...params);

        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, SsmError);
        }

        this.name = 'SsmError';
        this.code = _code || GENERIC_SSM_SETUP_ERROR_CODE;
    }
}

export default SsmError;
